module.exports = __webpack_public_path__ + "static/media/icon.e3d56546.png";